import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function usersReducer(state = initialState.users, action) {
    switch (action.type) {
        case types.LOAD_USERS_SEARCH_SUCCESS:
            return action.users;
        case types.NETWORK_FOLLOW_RIDER:
            return state;
        case types.NETWORK_UNFOLLOW_RIDER:
            return state;
        case types.LOGOUT_SUCCESS:
            return initialState.users;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/usersReducer.js